import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="text-xs md:text-sm text-gray-500 py-3" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1">
      {items.map((it, i) => (
        <li key={it.url} className="flex items-center gap-1">
          {i > 0 && <ChevronRight size={13} className="text-gray-400" />}
          {i === items.length - 1 ? (
            <span className="text-brand-red font-medium" aria-current="page">{it.name}</span>
          ) : (
            <Link to={it.url} className="hover:text-brand-red transition-colors">{it.name}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
